export default "__VITE_ASSET__545caa89__"